import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=34097b52&scoped=true"
import script from "./ResetPassword.js?vue&type=script&lang=js&external"
export * from "./ResetPassword.js?vue&type=script&lang=js&external"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=34097b52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34097b52",
  null
  
)

export default component.exports